export function forceEncodingToSystem(encoding, system = 0x00) {
  encoding = encoding.slice();
  if (encoding[0] !== system) encoding[0] = system;
  return encoding;
}
